import { createContext, useContext, ReactNode, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { initInterceptors } from 'src/shared/services/axios/axios';

interface AxiosContextType {
  isAxiosReady: boolean;
}

const AxiosContext = createContext<AxiosContextType>({ isAxiosReady: false });

export const useAxiosReady = () => {
  const context = useContext(AxiosContext);
  if (!context) {
    throw new Error('useAxiosReady must be used within AxiosProvider');
  }
  return context;
};

/**
 * Provider that initializes axios interceptors once at the app level.
 * This prevents redundant initialization across multiple components.
 */
export const AxiosProvider = ({ children }: { children: ReactNode }) => {
  const [isAxiosReady, setIsAxiosReady] = useState(false);
  const auth = useAuth();

  useEffect(() => {
    if (auth.user?.access_token) {
      initInterceptors(auth.user.access_token);
      setIsAxiosReady(true);
    } else {
      setIsAxiosReady(false);
    }
  }, [auth.user?.access_token]);

  return <AxiosContext.Provider value={{ isAxiosReady }}>{children}</AxiosContext.Provider>;
};
